import { useEffect, useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicPage } from "../theme/Component/BasicPage"
import { SelectBudgetType } from "../admin/configuracion/select/SelectBudgetType";
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { BasicButton } from "../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import usePaginator from "../theme/Component/usePaginator";
import { ListMenu } from "../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { DropDown } from "../theme/Component/DropDown";
import AutoChart from "../../core/graph/AutoChart";
import { ViewBudgetDocuments } from "./ViewBudgetDocuments";
import { SelectMonths } from "../contract/select/SelectMonths";
import { AccountEditor } from "../editor/AccountEditor";

export const BudgetReportByRP = () => {

    const _budget = useDataBean(_BudgetID);
    const { instance, lista, setLista, bean, setBean } = _budget;
    const [data, setData] = useState<any>({

    });
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [type, setType] = useState<number>(26);
    const paginador = usePaginator();
    const modalDocumentos = useModal("Documentos", MODAL_LG);
    const modalGraph = useModal("Grafica", MODAL_XL);

    useEffect(() => {
        getBudgetYearByProps();
    }, [paginador.page])
    useEffect(() => {
        paginador.setPage(1);
    }, [data])

    const getBudgetYearByProps = () => {
        console.log(data);

        if (year > 0 && data.IDBudgetType >= 0) {
            instance.getRPDetailByYear(year, 1, 15000, _single.cleanMap(data)).then(
                (resp: any) => {
                    if (resp.List) {                        
                        paginador.setPages(resp.NumberOfPages);
                        setLista(resp.List);
                    }
                }
            ).catch(err => toast.error(err));

        } else {
            toast.warning("Año y tipo de presupuesto obligatorio");
        }
    }

    const head25 = [
        
        { title: 'CDP', property: 'CDPStr', visible: true },        
        { title: 'Vr. CDP', property: 'CDPValue', visible: true,mask:MASK_MONEY },
        { title: 'Fecha CDP', property: 'CDPDocumentDate', visible: true },        
        { title: 'Codigo Bpin', property: 'BPINCode', visible: true ,mask:MASK_NUMBER},        
        { title: 'Producto', property: 'Producto', visible: true },        
        { title: 'Actividad', property: 'Actividad', visible: true },        
        { title: 'RP', property: 'RPStr', visible: true },        
        { title: 'Vr. RP', property: 'RPValue', visible: true,mask:MASK_MONEY },
        { title: 'Fecha RP', property: 'RPDocumentDate', visible: true },        
        { title: 'Tercero RP', property: 'RPAccountName', visible: true },        
        { title: 'OB', property: 'OBStr', visible: true },        
        { title: 'Vr. OB', property: 'OBValue', visible: true,mask:MASK_MONEY },
        { title: 'Fecha OB', property: 'OBDocumentDate', visible: true },        
        { title: 'Tercero OB', property: 'OBAccountName', visible: true },        
        { title: 'CE', property: 'CEStr', visible: true },        
        { title: 'Vr. CE', property: 'CEValue', visible: true,mask:MASK_MONEY },
        { title: 'Fecha CE', property: 'CEDate', visible: true },        
        { title: 'Tercero CE', property: 'CEAccountName', visible: true },        

       


    ]
  

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documentos', icono: 'ri-git-merge-line', visible: true, evento: () => { modalDocumentos.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Detallado por Registro Presupuestal (RP)">
            <div className="row">
                <div className="col-md-3">
                    <SelectBudgetType idType={type} idSelector={data.IDBudgetType} onChange={(e) => { setData({ ...data, "IDBudgetType": parseInt(e) }) }} />
                </div>
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-2">
                    <SelectMonths label="Mes" idSelector={data.Month} onChange={(e)=>{setData({...data,Month:e})}}/>
                </div>
                <div className="col-md-3">
                    <AccountEditor label="Tercero" idAccount={data.IDAccountRP} onChange={(e)=>{setData({...data,IDAccountRP:e.IDAccount})}}/>
                </div>               
                <div className="col-md-3 ">
                    <BasicButton useMargin icon="" eventClick={getBudgetYearByProps}>Buscar</BasicButton>
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-12">
                    <BasicTable  head={head25} body={lista} rowSet={setBean} 
                    
                    ></BasicTable>
                    {/* <PrintJson json={lista}/> */}
                    <Modal modal={modalDocumentos.modal} updateModal={modalDocumentos.setModal}>
                        <ViewBudgetDocuments year={year} row={bean}/>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head25} useIndexAsXLabel={true}
                            xOptions={['NameBudgetType', 'BudgetIDStr', 'NameBudgetResource', 'NameBudgetSource', 'IsAusterity']}
                            yOptions={['PIValue', 'CCValue', 'CDPValue', 'RCDPValue', 'RPValue', 'OBValue', 'CEValue']} />

                    </Modal>
                </div>
            </div>

        </BasicPage>
    )
}